import styled from "styled-components";

import { colors } from "../../consts";
import { Paragraph2, WrapperContainer } from "../../components";

export const TextWrapper = styled(WrapperContainer)`
  text-align: center;

  ${Paragraph2} {
    font-weight: 600;
    color: ${colors.RAISIN_50};
  }
`;
